module.exports = "https://la-static.vkplay.ru/promo/luckybox/img/logo-smilegate.934c0b3b.svg";